/** URL search of the settings page: the open tab (links can open a tab directly, e.g. ?tab=profile). */
export const SETTINGS_TABS = ['security', 'profile', 'preferences', 'store-users', 'api-keys'] as const;
export type SettingsTab = (typeof SETTINGS_TABS)[number];

export interface SettingsSearch {
  tab?: SettingsTab;
}

export function isSettingsTab(candidate: unknown): candidate is SettingsTab {
  return SETTINGS_TABS.some((settingsTab) => settingsTab === candidate);
}

export function validateSettingsSearch(rawSearch: Record<string, unknown>): SettingsSearch {
  return isSettingsTab(rawSearch.tab) ? { tab: rawSearch.tab } : {};
}
